import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { InlineLoader, Tutorial } from '../../components'
import {
  selectCurrentTutorialId,
  selectTutorials,
  selectCurrentPhoneTutorialId,
  selectCurrentTutorial,
  structuredTutorialState
} from './selectors'
import {
  fetchTutorialList,
  fetchTutorialSteps,
  updateStep,
  playStepAnimation,
  playAllStepAnimation
} from './actions'
import {
  selectCurrentPhoneId,
  selectPreSaleFlag,
  selectCustomer,
  selectLanguage
} from '../App/selectors'
import { createEvent } from '../UserEvents/actions'
import { fetchRelatedApi } from '../RelatedSidebar/services'
import languages from '../../constants/languages'

class TutorialsEmbedContainer extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { relatedData: [], isFetching: true, width: 0, height: 0 }

    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentDidMount() {
    const {
      updateCurrentTutorial,
      tutorials,
      currentPhoneId,
      currentPhoneTutorialId,
      fetchTutorialList,
      routeParams,
      query
    } = this.props

    if (currentPhoneId !== currentPhoneTutorialId || tutorials.length === 0) {
      fetchTutorialList(currentPhoneId)
    } else {
      if (routeParams.hasOwnProperty('id')) {
        updateCurrentTutorial(parseInt(routeParams.id, 10))
      } else {
        this.context.router.push({
          pathname: `/tutorials/${tutorials[0].children[0].pk}`,
          query: query
        })
      }
    }

    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillMount() {
    this.updateDimensions()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions() {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName('body')[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height =
        w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({ width: width, height: height })
  }

  componentWillReceiveProps(nextProps) {
    const {
      updateCurrentTutorial,
      tutorials,
      currentPhoneId,
      currentTutorialId,
      fetchTutorialList,
      routeParams,
      language,
      query,
      preSaleFlag,
      customer
    } = this.props

    if (tutorials.length === 0 && nextProps.tutorials.length !== 0) {
      if (routeParams.hasOwnProperty('id')) {
        updateCurrentTutorial(parseInt(routeParams.id, 10))
      } else {
        this.context.router.push({
          pathname: `/tutorials/${nextProps.tutorials[0].children[0].pk}`,
          query: query
        })
      }
    }

    if (tutorials.length > 0 && routeParams.id !== nextProps.routeParams.id) {
      if (isNaN(nextProps.routeParams.id)) {
        this.context.router.push({
          pathname: `/tutorials/${nextProps.tutorials[0].children[0].pk}`,
          query: query
        })
      } else {
        updateCurrentTutorial(parseInt(nextProps.routeParams.id, 10))
      }
    }

    if (
      (currentTutorialId !== nextProps.currentTutorialId ||
        routeParams.id !== nextProps.routeParams.id ||
        !this.state.relatedData.length) &&
      nextProps.currentTutorialId
    ) {
      this.setState({ isFetching: true })

      let preSaleURL = preSaleFlag ? '&presales=1' : ''
      fetchRelatedApi({
        contentType: 'tutorial',
        id: nextProps.currentTutorialId,
        language: languages[language],
        currentPhoneId: currentPhoneId,
        preSaleURL: preSaleURL,
        customer
      }).then(json => this.setState({ relatedData: json, isFetching: false }))
    }

    if (currentPhoneId !== nextProps.currentPhoneId) {
      fetchTutorialList(nextProps.currentPhoneId)
    }
  }

  render() {
    const {
      createUserEvent,
      currentTutorial,
      tutorials,
      updateStep,
      language,
      playStepAnimation,
      tutorialState,
      playAllStepAnimation
    } = this.props

    return (
      <div id="content">
        <Choose>
          <When
            condition={tutorials.length === 0 || currentTutorial.length === 0}
          >
            <InlineLoader style={{ margin: '0 auto', display: 'block' }} />
          </When>
          <Otherwise>
            <Tutorial
              createUserEvent={createUserEvent}
              updateStep={updateStep}
              language={language}
              data={tutorialState.tutorial}
              dropdownCount={Math.max(
                tutorialState.infoBar.categories.length,
                tutorialState.infoBar.categoryTutorials.length
              )}
              playStepAnimation={playStepAnimation}
              playAllStepAnimation={playAllStepAnimation}
              windowDimensions={{
                width: this.state.width,
                height: this.state.height
              }}
            />
          </Otherwise>
        </Choose>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentPhoneId: selectCurrentPhoneId(state),
  currentPhoneTutorialId: selectCurrentPhoneTutorialId(state),
  currentTutorial: selectCurrentTutorial(state),
  language: selectLanguage(state),
  query: state.routing.locationBeforeTransitions.query,
  currentTutorialId: selectCurrentTutorialId(state),
  tutorials: selectTutorials(state),
  preSaleFlag: selectPreSaleFlag(state),
  tutorialState: structuredTutorialState(state),
  customer: selectCustomer(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event)),
  fetchTutorialList: currentPhoneId =>
    dispatch(fetchTutorialList.request(currentPhoneId)),
  updateCurrentTutorial: tutorialId =>
    dispatch(fetchTutorialSteps.request(tutorialId)),
  updateStep: step => dispatch(updateStep(step)),
  playStepAnimation: () => dispatch(playStepAnimation()),
  playAllStepAnimation: () => dispatch(playAllStepAnimation())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TutorialsEmbedContainer)



// WEBPACK FOOTER //
// ./src/containers/Tutorials/TutorialsEmbed.js